module.exports = __webpack_public_path__ + "static/image2-02fcbb2517a5c8875f4c079a52ae5d00.jpg";